import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  customStyle,
  tableLoading,
  formatPrice,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';
import Moment from "react-moment";
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";
import ReportTypeOptions from "../../../components/Reports/ReportTypeOptions";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const CancelOrderReport = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let { loading, setLoading, dataPaginating, generalSettings } =
    useContext(SettingsContext);
  let { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);

  let [newCancelOrderReport, setNewCancelOrderReport] = useState(null);

  //all data
  const [reportData, setReportData] = useState(null);

  const componentRef = useRef();
  const componentRefThermalDetail = useRef();
  //settle order
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  const [reportOption,setReportOption] = useState("excel")
  //useEffect == componentDidMount()
  const [branchSearch, setBranchSearch] = useState(null);

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
    if (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") {
      setBranchSearch(
        branchForSearch.filter(
          (branch) => branch.id === authUserInfo.details.branch_id
        )
      );
    } else {
      setBranchSearch(branchForSearch);
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  //Print Report
  const ReportPrint = useRef();

  const handlePrintBtn = useReactToPrint({
    content: () => ReportPrint.current,
  });

  const thermalPrintDetail = useReactToPrint({
    content: () => componentRefThermalDetail.current,
    pageStyle: `@page {margin: 5px;}`,
  });

  const handleReportOption  = (e) =>{
    setReportOption(e.target.value)
  }

  const handleBranch = (branch) => {
    setNewCancelOrderReport({
      ...newCancelOrderReport,
      branch,
    });
    // setBranch(branch);
  };

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    console.log("newCancelOrderReport ", newCancelOrderReport);
    if (
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      newCancelOrderReport?.branch?.id === undefined
    ) {
      toast.error(`${_t(t("Please select Branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if (
      // newCancelOrderReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null
    ) {
      setLoading(true);
      var fromDate = moment(startDate).format("YYYY-MM-DD");
      var toDate =  moment(endDate).format("YYYY-MM-DD");

      const url = BASE_URL + "/settings/get-cancel-order-report";

      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", newCancelOrderReport?.branch?.id);
      console.log("formData ", formData);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("CancelOrderReportResult", res);
          setReportData(res.data[0]);

          setLoading(false);
          console.log("Component ", componentRef);
          setGeneratedReport(true);
          if(reportOption === "print"){
            thermalPrintDetail();
          }else{
            componentRef.current.handleDownload();
          }
          setNewCancelOrderReport(null);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and generate report"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  let total_payable = 0;
  let totalPayable = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Cancel Order Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Cancel Order Report"
        sheet="sheet 1"
        buttonText="Sales Detail"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          {console.log("reportData", reportData)}
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="11" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Cancel Order Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Branch"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cust Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cust Contact#"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Address"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Order Punch Time"))}
                                  </th>
                                  <th
                                    scope="col"
                                  >
                                    {_t(t("Cancel Time"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Total Bill"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData.map((item, i) => {
                                  total_payable += parseFloat(
                                    item.total_payable
                                  );
                                  return (
                                    <tr>
                                      <td
                                        scope="row"
                                      >
                                        {i + 1}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <Moment format="LL">
                                          {item.created_at}
                                        </Moment>
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.branch_name}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.token?.id}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.customer_name}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.customer_phn_no}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.customer_address}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.order_type_name}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {item.punching_time}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <Moment format="hh:mm A">
                                          {item.created_at}
                                        </Moment>
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        {formatPrice(item.total_payable)}
                                      </td>
                                    </tr>
                                  );
                                })}
                                <tr>
                                  <th
                                    colspan="9"
                                    style={{ border: "0px" }}
                                  ></th>
                                  <th className="sm-text text-capitalize align-middle text-center border-1 border">
                                    Total
                                  </th>
                                  <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                    {formatPrice(total_payable)}
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Button thermal */}
      <div className="d-none">
        <div ref={componentRefThermalDetail}>
          <div className="fk-print">
            <div className="container-fuild">
              <div className="row">
                <div className="col-12">
                  {reportData !== null && reportData &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="11" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Cancel Order Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Order Date"))}
                                  </th>
                                  <th className="border border-1 table_child_token"
                                  >
                                    {_t(t("Token"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Branch Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Custome Name"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Customer Phone"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Cust Address"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Order Type"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Order Punch Time"))}
                                  </th>
                                  <th className="border border-1 table_child_total"
                                  >
                                    {_t(t("Cancel Time"))}
                                  </th>
                                  <th className="border border-1 table_report_col"
                                  >
                                    {_t(t("Total Bill"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData.map((item, i) => {
                                  totalPayable += parseFloat(item.total_payable);
                                  return (
                                    <tr>
                                      <td>
                                        <Moment format="LL">
                                          {item.created_at}
                                        </Moment>
                                      </td>
                                      <td>
                                        {item.token.id}
                                      </td>
                                      <td>
                                        {item.branch_name}
                                      </td>
                                      <td>
                                        {item.customer_name}
                                      </td>
                                      <td>
                                        {item.customer_phn_no}
                                      </td>
                                      <td>
                                        {item.customer_address}
                                      </td>
                                      <td>
                                        {item.order_type_name}
                                      </td>
                                      <td>
                                        {item.punching_time}
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <Moment format="hh:mm A">
                                          {item.created_at}
                                        </Moment>
                                      </td>
                                      <td>
                                        {item.total_payable}
                                      </td>
                                    </tr>
                                  );
                                })}
                                <tr></tr>
                                
                                <tr>
                                  <th
                                    colspan="8"
                                    style={{ border: "0px" }}
                                  ></th>
                                  <th className="sm-text text-capitalize align-middle text-center border-1 border">
                                    Total
                                  </th>
                                  <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                    {formatPrice(total_payable)}
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="11"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-6 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t("Cancel Order Report"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                          <div className="col-6 d-flex justify-content-end p-0">
                            <ReportTypeOptions
                              selectedOption={reportOption}
                              onChange={handleReportOption}
                            />
                          </div>
                        </div>
                        <div className="row gx-2 mt-2">
                          <div className="col-2 d-md-block">
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control sm-text py-2 t-mb-15 mb-md-0"
                              placeholderText={_t(t("From date"))}
                              shouldCloseOnSelect={false}
                            />
                          </div>
                          <div className="col-2 t-mb-15 mb-md-0">
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control sm-text py-2"
                              placeholderText={_t(t("To date"))}
                              shouldCloseOnSelect={false}
                            />
                          </div>
                          <div className="col-3 t-mb-15 mb-md-0">
                            <Select
                              options={branchSearch ? branchSearch : []}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              value={newCancelOrderReport?.branch || ""}
                              styles={customStyle}
                              classNamePrefix="select"
                              className="sm-text "
                              onChange={handleBranch}
                              maxMenuHeight="200px"
                              placeholder={_t(t("Select a branch")) + ".."}
                            />
                          </div>
                          <div className="col-2"></div>
                          <div className="col-3 t-mb-15 mb-md-0 d-none d-md-block text-right">
                            {/* Action Button */}
                            <button
                              className="btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                              onClick={(e) => getBranchWiseSelected(e)}
                            >
                              Print Cancel Order Report
                            </button>
                          </div>
                        </div>
                      </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default CancelOrderReport;
